module.exports = __webpack_public_path__ + "img/HeadExtraction03.cfe8ba36.png";